import React from 'react';
import { Link } from 'react-router-dom';

export default function SavedHostProspects({ data, loading, error }) {
  if (!data && !loading && !error) return null;
  return (
    <section aria-label="Saved prospects" style={{ marginBottom: 28 }}>
      <h2 style={{ fontSize: 18, margin: '0 0 8px' }}>Saved prospects</h2>
      <p className="hf-sub">
        Previously added or imported into the portal · All programs · Independent of the external directory
      </p>
      {loading && <p role="status">Loading saved prospects…</p>}
      {error && <div className="hf-error" role="alert">{error} <Link to="/host-prospects">Open Host Prospects</Link></div>}
      {data && <>
        <p role="status">{data.count} saved prospects in {data.city}, {data.province}.
          {data.limited && <> Showing the first 500; use Host Prospects to view the full list.</>}
        </p>
        {data.count === 0 && <p className="hf-sub">No saved prospects matched this location. <Link to="/host-prospects">View all saved prospects</Link>.</p>}
        <div className="hf-grid">
          {data.results.map(host => (
            <article className="hf-card" key={host.id}>
              <div className="hf-card-top">
                <div className="hf-card-name">{host.org_name}</div>
                <span className="hf-tag">Saved prospect</span>
              </div>
              <div className="hf-card-addr">
                {[host.address, host.city, host.province].filter(Boolean).join(', ')}
              </div>
              {host.provinceUnconfirmed && <div className="hf-sub">Province not recorded — confirm before outreach.</div>}
              <div className="hf-sub">{(host.programs_accepted || []).join(' · ') || 'Program not recorded'}</div>
              <div className="hf-card-contacts">
                {host.contact_phone && <a className="hf-contact" href={`tel:${host.contact_phone}`}>{host.contact_phone}</a>}
                {host.contact_email && <a className="hf-contact" href={`mailto:${host.contact_email}`}>{host.contact_email}</a>}
                {/^https?:\/\//i.test(host.website || '') && <a className="hf-contact" href={host.website} target="_blank" rel="noreferrer">Website</a>}
              </div>
              <div className="hf-card-foot"><Link className="hf-add-btn" to={`/hosts/${host.id}`}>Open saved prospect</Link></div>
            </article>
          ))}
        </div>
      </>}
    </section>
  );
}
